import { CircleAlertIcon } from "lucide-react";

import type { ChatError } from "~/ai-chat/model/chat-message";

interface ChatErrorBubbleProps {
  error: ChatError;
}

export function ChatErrorBubble({ error }: ChatErrorBubbleProps) {
  return (
    <div
      role="alert"
      className="border-destructive/30 bg-destructive/10 text-destructive flex items-start gap-2 rounded-md border px-3 py-2 text-xs"
    >
      <CircleAlertIcon className="mt-0.5 size-3.5 shrink-0" />
      <span className="leading-snug whitespace-pre-wrap">{error.content}</span>
    </div>
  );
}
